import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isPromise = function isPromise(val) {
  return val && Ext.utils.isFunction(val.then);
};

var promiseMiddleware = function promiseMiddleware(store) {
  return function (next) {
    return function (action) {
      var dispatch = store.dispatch;
      return isPromise(action.payload) ? action.payload.then(function (result) {
        return dispatch(_objectSpread(_objectSpread({}, action), {}, {
          payload: result
        }));
      }, function (error) {
        return dispatch(_objectSpread(_objectSpread({}, action), {}, {
          payload: error,
          error: true
        }));
      }) : next(action);
    };
  };
};

export default promiseMiddleware;